import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { OneBtnFooter } from 'widgets/HsptlzForm/ui';
import { ReadonlyFormContainer } from 'features/HsptlzForm/ui';

import { Noti } from './Noti';
import Title from './Title';

export const ReadonlyFormWrap = () => {
  const navigate = useNavigate();
  const patientInfoData = useBoundStore((state) => state.hsptlzForm.patientInfoData);
  const [isValidData, setIsValidData] = useState(!!(patientInfoData.postNo && patientInfoData.usrTelNo));
  const submitValid = !!(patientInfoData.postNo && patientInfoData.usrTelNo);

  return isValidData ? (
    <div className='confirm-info-readonly'>
      <Title>
        <Title.Main />
        <Title.Sub />
      </Title>
      <ReadonlyFormContainer />
      <OneBtnFooter
        text={'저장 후 다음'}
        handleClick={() => navigate(patientInfoData.redirectUrl)}
        disabled={!submitValid}
        isValid={submitValid}
      />
    </div>
  ) : (
    <Noti setIsValidData={setIsValidData} />
  );
};
